import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader } from "@revvsales/components";

import ImageChangePopup from "./ImageChangePopup";

class DropzoneFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hightlight: false,
      showChangeImagePopup: false,
      errMsg: "",
    };
    this.fileInputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.toggleBrowse !== this.props.toggleBrowse) {
      this._openFileDialog();
    }
  }

  _onFilesAdded = evt => {
    if (this.props.disabled) return;
    let fileName;
    // let result;
    if (evt.target || evt[0]) {
      if (!evt[0].fileType.includes("image")) {
        this.setState({
          errMsg: this.props.uploadImageTypeMessage,
        });
        return;
      }
      if (evt.target) {
        const {
          target: { files },
        } = evt;
        fileName = files;
      } else if (evt[0].file) {
        const { file } = evt[0];
        fileName = file;
      }

      if (this.props.onFilesAdded) {
        const array = this.fileListToArray(fileName, evt);
        this.setState({ errMsg: "" });
        this.props.onFilesAdded(array);
        this.setState({
          errMsg: "",
          showChangeImagePopup: false,
        });
      }
    } else {
      fileName = evt.regular;
      this.props.onFilesAdded(fileName);
      this.setState({
        errMsg: "",
        showChangeImagePopup: false,
      });
    }
  };

  onDragOver = evt => {
    evt.preventDefault();

    if (this.props.disabled) return;

    this.setState({ hightlight: true });
  };

  onDragLeave = () => {
    this.setState({ hightlight: false });
  };

  _onDrop = event => {
    event.preventDefault();

    if (this.props.disabled) return;
    if (event.dataTransfer.items) {
      const filesList = [];
      for (let i = 0; i < event.dataTransfer.items.length; i += 1) {
        if (event.dataTransfer.items[i].kind === "file") {
          filesList.push(event.dataTransfer.items[i].getAsFile());
        }
      }
      if (this.props.onFilesAdded) {
        this.props.onFilesAdded(filesList);
      }
    }
    this.setState({ hightlight: false });
  };

  _openFileDialog = () => {
    this.setState({
      showChangeImagePopup: true,
    });
  };

  _onCloseImagePopup = () => {
    this.setState({
      showChangeImagePopup: false,
    });
  };

  fileListToArray = (list, event) => {
    const array = [];
    if (event.target) {
      for (let i = 0; i < list.length; i += 1) {
        array.push(list.item(i));
      }
    } else {
      array.push(list);
    }
    return array;
  };

  _getImgInputPlaceholder = () => {
    const { totalRowItems } = this.props;
    let className = "image-placeholder-text ";
    if (totalRowItems >= 2 && totalRowItems < 4) {
      className += " size-medium ";
    } else if (totalRowItems >= 4) {
      className += " size-small ";
    }
    return (
      this.props.placeholder || (
        <React.Fragment>
          <span className={className}>
            <FontAwesomeIcon
              icon={["far", "image"]}
              className="image-placeholder-icon"
            />
            {totalRowItems >= 2 && <br />}
            Drag & drop image files {totalRowItems > 2 && <br />} or
            <span className="image-placeholder-style">browse</span> to upload
          </span>
        </React.Fragment>
      )
    );
  };

  render() {
    // Image upload and unsplash image popup
    if (this.state.showChangeImagePopup) {
      return (
        <ImageChangePopup
          show={this.state.showChangeImagePopup}
          onCloseImagePopup={this._onCloseImagePopup}
          uploadDocument={this._onFilesAdded}
          type="imageComponent"
          errMsg={this.state.errMsg}
        />
      );
    }

    let className = `dropzone-files ${this.props.className}`;
    if (this.props.checkImgUploadLoader && !this.props.imageData) {
      className = `dropzone-loader-state ${this.props.className}`;
    }
    if (this.state.hightlight) {
      className = `dropzone-files-highlight ${this.props.className}`;
    }
    return (
      <div
        className={className}
        onDragOver={!this.props.disabled ? this.onDragOver : () => {}}
        onDragLeave={!this.props.disabled ? this.onDragLeave : () => {}}
        onDrop={!this.props.disabled ? this._onDrop : () => {}}
        onClick={!this.props.disabled ? this._openFileDialog : () => {}}
        tabIndex="0"
        role="button"
        onKeyPress={() => {}}
        style={{
          cursor: this.props.disabled ? "default" : "pointer",
        }}>
        {/* ---------- Image input field section ---------- */}
        <input
          data-test="dropzone-file-input"
          ref={this.fileInputRef}
          className="dropzone-file-input"
          type="file"
          multiple={this.props.multiple}
          onChange={!this.props.disabled ? this._onFilesAdded : () => {}}
        />
        {/* ---------- Uploading loader and image placeholder section ---------- */}
        {this.props.checkImgUploadLoader ? (
          <Loader label="Uploading" />
        ) : (
          this._getImgInputPlaceholder()
        )}
      </div>
    );
  }
}

DropzoneFiles.propTypes = {
  disabled: PropTypes.bool.isRequired,
  multiple: PropTypes.bool.isRequired,
  onFilesAdded: PropTypes.func.isRequired,
  toggleBrowse: PropTypes.bool.isRequired,
};

export default DropzoneFiles;



// WEBPACK FOOTER //
// ./src/commonComponents/DropzoneFiles/DropzoneFiles.js